import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=2dd03f04&scoped=true"
import script from "./ConversationList.vue?vue&type=script&lang=js"
export * from "./ConversationList.vue?vue&type=script&lang=js"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=2dd03f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd03f04",
  null
  
)

export default component.exports